import type { HomePageVariant } from '@/interface/home-pages';

export const HOME_PAGES_V2 = { key: 'home-v2', cta: 'assine', visual: 'app' } as const satisfies HomePageVariant;
